// Curated image assets used alongside icons across the app.
// Source: Unsplash (via design_guidelines.json + additional picks that fit the calm-care aesthetic).

export const HERO = {
  loginSide: "https://images.unsplash.com/photo-1587560699334-cc4ff634909a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

// Small circular decorative avatars keyed by nav route
export const NAV_ART = {
  "/": "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  "/children": "https://images.unsplash.com/photo-1552873816-636e43209957?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  "/staff": "https://images.unsplash.com/photo-1573497019418-b400bb3ab074?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  "/attendance": "https://images.unsplash.com/photo-1607453998774-d533f65dac99?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  "/messages": "https://images.unsplash.com/photo-1611746872915-64382b5c76da?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  "/daily-reports": "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  "/iep": "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  "/sessions": "https://images.unsplash.com/photo-1685362158423-abf004b858d2?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  "/whatsapp": "https://images.unsplash.com/photo-1611746872915-64382b5c76da?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  "/audit": "https://images.unsplash.com/photo-1568992687947-868a62a9f521?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  "/emergency": "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  "/monthly": "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  "/evaluations": "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  "/whatsapp-templates": "https://images.unsplash.com/photo-1611746872915-64382b5c76da?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
};

// Stat card decorative images (dashboard)
export const STAT_ART = {
  children: "https://images.unsplash.com/photo-1587653263995-422546a7a569?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  teachers: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  present: "https://images.unsplash.com/photo-1607453998774-d533f65dac99?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
  absent: "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?crop=entropy&cs=srgb&fm=jpg&q=85&w=300",
};

// Rotating child portrait fallbacks
export const CHILD_PORTRAITS = [
  "https://images.unsplash.com/photo-1552873816-636e43209957?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  "https://images.unsplash.com/photo-1624272949900-9ae4c56397e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  "https://images.unsplash.com/photo-1614900327600-1261b13586f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  "https://images.unsplash.com/photo-1498674202614-ac0172c6c61a?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
];

export function portraitFor(id) {
  if (!id) return CHILD_PORTRAITS[0];
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return CHILD_PORTRAITS[h % CHILD_PORTRAITS.length];
}
